import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5cce4e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "note-board" }
const _hoisted_2 = { class: "contents" }
const _hoisted_3 = { class: "search" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "detail" }
const _hoisted_7 = {
  key: 0,
  class: "title line1"
}
const _hoisted_8 = { class: "tools" }
const _hoisted_9 = {
  key: 1,
  class: "text"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1))

import api from '@/api/userApi';
import device from '@/store/device';
import notes, { State } from '@/store/mine/notes';
import { computed, onMounted, reactive, ref, watch } from 'vue';
import { useStore } from 'vuex';
import i18, { State as I18State } from '@/store/i18';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const data = computed<State>(() => store.state[notes.name])

const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].mineText)

const state = reactive({
    content: '',
    search: '',
    search0: '',
})
const filterlist = computed(() => {
    if (state.search0) {
        return data.value.list.filter(item => item.movie.title.indexOf(state.search0) >= 0 || item.url.title.indexOf(state.search0) >= 0)
    } else {
        return data.value.list
    }
})
const current = ref<NoteRecord | undefined>()
onMounted(async () => {
    await notes.loadList(store)
    if (data.value.list.length > 0) {
        getDetail(data.value.list[0])
    }
})

async function getDetail(item: NoteRecord) {
    if (current.value && current.value.id == item.id) {
        return
    }
    current.value = item;
    state.content = ''
    let result = await api.getNote(item.urlid, item.movid)
    if (result) {
        state.content = result.content
    }
}

async function onSave() {
    if (!current.value) {
        return
    }
    try {
        await api.saveNote({
            id: current.value.id,
            title: current.value.movie.title,
            subtitle: current.value.url.title,
            content: state.content
        })
        device.toast(store, lang.value.successSave)
    } catch (e) {
        device.toast(store, lang.value.errorSave)
    }
}

async function onRemove() {
    if (!current.value) {
        return
    }
    try {
        let i = data.value.list.findIndex(item => item.id == current.value?.id)
        await notes.remove(store, i)
        device.toast(store, lang.value.successDelete)
        current.value = undefined
    } catch (e) {
        device.toast(store, lang.value.errorDelete)
    }
}

watch(() => state.search, doSearch())

function doSearch() {
    let timer = 0
    return function () {
        clearTimeout(timer)
        //@ts-ignore
        timer = setTimeout(() => {
            state.search0 = state.search.trim();
        }, 500);
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).search) = $event)),
            placeholder: _unref(lang).noteSearchPlaceholder
          }, null, 8, _hoisted_4), [
            [_vModelText, _unref(state).search]
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filterlist), (item, i) => {
          return (_openBlock(), _createElementBlock("a", {
            class: _normalizeClass(["item line1 link", { on: current.value && current.value.id == item.id }]),
            onClick: ($event: any) => (getDetail(item))
          }, _toDisplayString(i + 1) + " " + _toDisplayString(item.movie.title) + " - " + _toDisplayString(item.url.title), 11, _hoisted_5))
        }), 256))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (current.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("a", {
                  class: "btn silver",
                  onClick: onSave
                }, _toDisplayString(_unref(lang).save), 1),
                _createElementVNode("a", {
                  class: "btn red",
                  onClick: onRemove
                }, _toDisplayString(_unref(lang).delete), 1)
              ]),
              _createElementVNode("span", null, _toDisplayString(current.value.movie.title) + " - " + _toDisplayString(current.value.url.title), 1)
            ]))
          : _createCommentVNode("", true),
        (current.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).content) = $event))
              }, null, 512), [
                [_vModelText, _unref(state).content]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_10
    ])
  ]))
}
}

})